export enum LearningHubSection {
  WELL_LOG_PLOT = "WELL_LOG_PLOT",
  INTERFACE = "INTERFACE",
  SCENE = "SCENE",
  TABLE = "TABLE",
  DATA_SCOPE = "DATA_SCOPE",
  FILTERING = "FILTERING",
  PRESETS = "PRESETS",
  ELEVATION_PROFILE = "ELEVATION_PROFILE",
  TOPOLOGY_EDITOR = "TOPOLOGY_EDITOR",
  DATA_UPLOAD = "DATA_UPLOAD",
  CODE_EDITOR = "CODE_EDITOR",
  CONSOLE = "CONSOLE",
  BUTTON = "BUTTON",
  DEBUG = "DEBUG",
  UPDATE_SCHEMA = "UPDATE_SCHEMA",
  PIPELINE_COLOR_LEGEND = "PIPELINE_COLOR_LEGEND",
  SCALE = "SCALE",
  PERFORMANCE = "PERFORMANCE",
  CAMERA = "CAMERA",
  LEARNING_HUB = "LEARNING_HUB",
  TASK_RUNNER = "TASK_RUNNER",
  VALUE_GRID = "VALUE_GRID",
  TIMELINE = "TIMELINE",
  GRAPH_VIEWER = "GRAPH_VIEWER",
  QR_LOGGING_SCANNER = "QR_LOGGING_SCANNER",
  QR_VALIDATION_SCANNER = "QR_VALIDATION_SCANNER",
  DOCUMENT_VIEW = "DOCUMENT_VIEW",
  DATA_PLOT = "DATA_PLOT",
  BUBBLE_MAP_SETTINGS = "BUBBLE_MAP_SETTINGS",
  WELL_PATH_COLOR_SETTINGS = "WELL_PATH_COLOR_SETTINGS",
  WELL_COLOR_SETTINGS = "WELL_COLOR_SETTINGS",
  PIPELINES_COLOR_SETTINGS = "PIPELINES_COLOR_SETTINGS",
  INFRASTRUCTURE_COLOR_SETTINGS = "INFRASTRUCTURE_COLOR_SETTINGS",
  GROUPS = "GROUPS",
  INSPECTOR = "INSPECTOR",
  GENERIC_AI = "GENERIC_AI",
}

export const ALL_LEARNING_HUB_SECTIONS = [
  LearningHubSection.WELL_LOG_PLOT,
  LearningHubSection.INTERFACE,
  LearningHubSection.SCENE,
  LearningHubSection.TABLE,
  LearningHubSection.DATA_SCOPE,
  LearningHubSection.FILTERING,
  LearningHubSection.PRESETS,
  LearningHubSection.ELEVATION_PROFILE,
  LearningHubSection.TOPOLOGY_EDITOR,
  LearningHubSection.DATA_UPLOAD,
  LearningHubSection.CODE_EDITOR,
  LearningHubSection.CONSOLE,
  LearningHubSection.BUTTON,
  LearningHubSection.DEBUG,
  LearningHubSection.UPDATE_SCHEMA,
  LearningHubSection.PIPELINE_COLOR_LEGEND,
  LearningHubSection.SCALE,
  LearningHubSection.PERFORMANCE,
  LearningHubSection.CAMERA,
  LearningHubSection.LEARNING_HUB,
  LearningHubSection.TASK_RUNNER,
  LearningHubSection.VALUE_GRID,
  LearningHubSection.TIMELINE,
  LearningHubSection.GRAPH_VIEWER,
  LearningHubSection.QR_LOGGING_SCANNER,
  LearningHubSection.QR_VALIDATION_SCANNER,
  LearningHubSection.DOCUMENT_VIEW,
  LearningHubSection.DATA_PLOT,
  LearningHubSection.BUBBLE_MAP_SETTINGS,
  LearningHubSection.WELL_PATH_COLOR_SETTINGS,
  LearningHubSection.WELL_COLOR_SETTINGS,
  LearningHubSection.PIPELINES_COLOR_SETTINGS,
  LearningHubSection.INFRASTRUCTURE_COLOR_SETTINGS,
  LearningHubSection.GROUPS,
  LearningHubSection.INSPECTOR,
];
